import { memo as l, useMemo as i } from "react";
import { Shape as p, MathUtils as c, DoubleSide as f } from "three";
import { jsxs as d, jsx as h } from "react/jsx-runtime";
const D = l(function({
  points: s,
  fill: m,
  opacity: t = 1,
  ...n
}) {
  const a = i(() => {
    const e = new p();
    for (let r = 0; r < s.length; r++) {
      const o = s[r];
      r === 0 ? e.moveTo(o.x, o.z) : e.lineTo(o.x, o.z);
    }
    return e.closePath(), e;
  }, [s]);
  return /* @__PURE__ */ d("mesh", {
    rotation: [90 * c.DEG2RAD, 0, 0],
    renderOrder: t !== 1 ? 1 : 0,
    ...n,
    children: [/* @__PURE__ */ h("shapeGeometry", {
      args: [a]
    }), /* @__PURE__ */ h("meshLambertMaterial", {
      color: m,
      side: f,
      opacity: t,
      transparent: t !== 1
    })]
  });
});
export {
  D as ShapeMesh
};
//# sourceMappingURL=index.js.map
